import { render, staticRenderFns } from "./impactos.vue?vue&type=template&id=a6be7404"
import script from "./impactos.vue?vue&type=script&lang=js"
export * from "./impactos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports